import React, { useState, useEffect } from "react";
import "../css/modal.css";
import { IoWarningOutline } from "react-icons/io5";
import EmailService from "../../modules/services/EmailService";

function ModalBoletoDigital({ isOpen, onClose, cliente, onClienteUpdate }) {
    const [emails, setEmails] = useState({
        boleto: "",
    });

    const [agree, setAgree] = useState(false);

    // Atualiza o email quando o modal abre ou quando o cliente muda
    useEffect(() => {
        if (isOpen && cliente) {
            const emailBoleto = cliente.emails.find(email => email.cdCategoriaEmail === 43);
            const emailAtual = emailBoleto?.dsEmail || "";
            setEmails({ boleto: emailAtual });
        }
    }, [isOpen, cliente]);

    if (!isOpen) return null;

    const handleSave = async () => {
        if (!agree) {
            alert("Você precisa concordar com os termos.");
            return;
        }

        try {
            // Verifica se o novo e-mail de boleto é diferente do atual
            const emailsToUpdate = {
                boleto: emails.boleto,
                nmResponsavel: cliente.razaoSocial,
            };

            const emailAtual = cliente?.emails.find(email => email.cdCategoriaEmail === 43)?.dsEmail;

            // Se o novo e-mail de boleto for igual ao atual, não faz nada
            if (emailsToUpdate.boleto === emailAtual) {
                alert("O e-mail de Boleto Digital não foi alterado.");
                return;
            }

            // Atualiza o e-mail de boleto digital
            await EmailService.atualizarEmails(cliente.cdCliente, {
                ...emailsToUpdate,
            });

            alert("E-mail de Boleto Digital atualizado com sucesso!");
            if (onClienteUpdate) {
                await onClienteUpdate();
            }
            onClose();
        } catch (error) {
            alert("Erro ao atualizar e-mail de Boleto Digital.");
        }
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <div className="topoModal">
                    <button className="modal-close" onClick={onClose}>✖</button>
                    <h3><b>Editar e-mail Boleto Digital</b></h3>
                </div>
                <p>Digite o novo endereço de e-mail abaixo. Enviaremos para este email um link de confirmação para concluir a alteração.</p>

                <label><b>E-mail Boleto Digital</b></label>
                <input
                    type="email"
                    placeholder="Digite o novo e-mail"
                    value={emails.boleto}
                    onChange={(e) => setEmails({ ...emails, boleto: e.target.value })}
                />

                <div className="modal-alert">
                    <IoWarningOutline size={70} />
                    Caso você não confirme a alteração pelo link enviado ao novo e-mail, seu endereço de e-mail atual permanecerá o mesmo.
                </div>

                <p>O endereço eletrônico para envio do Boleto Digital é de responsabilidade do informante.</p>

                <div className="modal-checkbox">
                    <input type="checkbox" checked={agree} onChange={() => setAgree(!agree)} />
                    <label className="textoAceite">Estou ciente destas obrigações e concordo</label>
                </div>

                <div className="modal-actions">
                    <button className="cancel" onClick={onClose}>Cancelar</button>
                    <button 
                        className={`confirm ${!agree ? 'disabled' : ''}`} 
                        onClick={handleSave}
                        disabled={!agree}
                    >
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ModalBoletoDigital;
